import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DraggableElement from './DraggableElement';
import getSurveyPermission from '../../../common/getPermissions';
import imageSources from '../../../constants/imageSources/imageSources';
import * as Styled from './styles';
import { sessionType, blockType } from '../../../types';
import elementTypes from '../../../constants/elementTypes';

class ElementsCollection extends PureComponent {
    state = {
        allowSurvey: false,
    };

    componentDidMount() {
        const { session } = this.props;
        const allowSurvey = getSurveyPermission(session);
        this.setState({ allowSurvey });
    }

    render() {
        const { canvasBlocks, session } = this.props;
        const { allowSurvey } = this.state;
        const isCanvasEmpty = canvasBlocks.length === 0;

        return (
            <Styled.ElementsCollection cursorSource={imageSources.ICONS.GRAB_CURSOR} isCanvasEmpty={isCanvasEmpty}>
                <div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                        <DraggableElement
                            index={0}
                            isEnabled
                            type={elementTypes.PARAGRAPH}
                            tooltipPosition="top"
                        />
                        <DraggableElement
                            index={1}
                            isEnabled
                            type={elementTypes.IMAGE}
                            tooltipPosition="top"
                        />
                        <DraggableElement
                            index={2}
                            isEnabled
                            type={elementTypes.BUTTON}
                            tooltipPosition="top"
                        />
                        {allowSurvey && (
                            <DraggableElement
                                index={3}
                                isEnabled
                                type={elementTypes.SURVEY}
                                tooltipPosition="top"
                            />
                        )}
                        <DraggableElement
                            index={0}
                            isEnabled={session.features.F_ELEMENT_VIDEO}
                            type={elementTypes.VIDEO}
                            tooltipPosition="bottom"
                            disabledTooltipOffset={{ right: 57, top: 20 }}
                        />
                        <DraggableElement
                            index={1}
                            isEnabled
                            type={elementTypes.SPACER}
                            tooltipPosition="bottom"
                        />
                        <DraggableElement
                            index={2}
                            isEnabled
                            type={elementTypes.SOCIAL}
                            tooltipPosition="bottom"
                        />
                    </div>
                </div>
            </Styled.ElementsCollection>
        );
    }
}

const mapStateToProps = (state) => ({
    canvasBlocks: state.canvasBlocks.present,
    session: state.session,
});

ElementsCollection.propTypes = {
    session: sessionType.isRequired,
    canvasBlocks: PropTypes.arrayOf(blockType).isRequired,
};

export default connect(mapStateToProps)(ElementsCollection);
